import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompletedControlEmptyState = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 77.173,
	height: 80.011,
	viewBox: "0 0 77.173 80.011",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_1170",
		"data-name": "Group 1170",
		transform: "translate(1560.603 -1191.035)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_1135",
				"data-name": "Group 1135",
				transform: "translate(-1553.29 1191.035)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1123",
						"data-name": "Group 1123",
						transform: "translate(0 7.183)",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_9990",
							"data-name": "Rectangle 9990",
							width: 63.199,
							height: 63.128,
							transform: "translate(63.199 63.128) rotate(180)",
							fill: "#e5eff9"
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1124",
						"data-name": "Group 1124",
						transform: "translate(0 0)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Rectangle_9991",
							"data-name": "Rectangle 9991",
							d: "M0,0H63.2a0,0,0,0,1,0,0V.062a6.386,6.386,0,0,1-6.386,6.386H6.386A6.386,6.386,0,0,1,0,.062V0A0,0,0,0,1,0,0Z",
							transform: "translate(63.199 6.448) rotate(180)",
							fill: "#032478"
						})
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1125",
						"data-name": "Group 1125",
						transform: "translate(0 7.183)",
						children: [
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9992",
								"data-name": "Rectangle 9992",
								width: 1.137,
								height: 63.128,
								transform: "translate(14.947)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9993",
								"data-name": "Rectangle 9993",
								width: 1.137,
								height: 63.199,
								transform: "translate(0 48.181) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9994",
								"data-name": "Rectangle 9994",
								width: 1.137,
								height: 63.199,
								transform: "translate(0 32.097) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9995",
								"data-name": "Rectangle 9995",
								width: 1.137,
								height: 63.199,
								transform: "translate(0 16.084) rotate(-90)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9996",
								"data-name": "Rectangle 9996",
								width: 1.137,
								height: 63.128,
								transform: "translate(31.031)",
								fill: "#f2f9ff"
							}),
							/* @__PURE__ */ _jsx("rect", {
								id: "Rectangle_9997",
								"data-name": "Rectangle 9997",
								width: 1.137,
								height: 63.128,
								transform: "translate(47.115)",
								fill: "#f2f9ff"
							})
						]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1126",
						"data-name": "Group 1126",
						transform: "translate(45.921 55.364)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1896",
							"data-name": "Path 1896",
							d: "M-1370.869,1370.391a56.281,56.281,0,0,1-1.632,12.784l-3.457,2.164h-12.188c2.316-6.162,2.33-14.948,2.33-14.948Z",
							transform: "translate(1388.147 -1370.391)",
							fill: "#2cd5c4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1897",
							"data-name": "Path 1897",
							d: "M-1348.662,1413.858v-2.214h3.457Z",
							transform: "translate(1360.85 -1398.91)",
							fill: "#2cb5a5"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1127",
						"data-name": "Group 1127",
						transform: "translate(29.837 39.28)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1898",
							"data-name": "Path 1898",
							d: "M-1422.974,1318.284a56.291,56.291,0,0,1-1.632,12.784l-3.457,2.164h-12.188c2.316-6.162,2.33-14.948,2.33-14.948Z",
							transform: "translate(1440.251 -1318.284)",
							fill: "#2cd5c4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1899",
							"data-name": "Path 1899",
							d: "M-1400.766,1361.751v-2.214h3.457Z",
							transform: "translate(1412.955 -1346.803)",
							fill: "#2cb5a5"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1128",
						"data-name": "Group 1128",
						transform: "translate(29.837 7.183)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1900",
							"data-name": "Path 1900",
							d: "M-1422.974,1214.305a56.291,56.291,0,0,1-1.632,12.784l-3.457,2.164h-12.188c2.316-6.162,2.33-14.948,2.33-14.948Z",
							transform: "translate(1440.251 -1214.305)",
							fill: "#2cd5c4"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1901",
							"data-name": "Path 1901",
							d: "M-1400.766,1257.771v-2.214h3.457Z",
							transform: "translate(1412.955 -1242.824)",
							fill: "#2cb5a5"
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1133",
						"data-name": "Group 1133",
						transform: "translate(13.753 23.267)",
						children: [/* @__PURE__ */ _jsxs("g", {
							id: "Group_1129",
							"data-name": "Group 1129",
							children: [/* @__PURE__ */ _jsx("path", {
								id: "Path_1902",
								"data-name": "Path 1902",
								d: "M-1475.078,1266.409a56.287,56.287,0,0,1-1.632,12.785l-3.457,2.164h-12.188c2.316-6.162,2.33-14.948,2.33-14.948Z",
								transform: "translate(1492.356 -1266.409)",
								fill: "#e3e4e5"
							}), /* @__PURE__ */ _jsx("path", {
								id: "Path_1903",
								"data-name": "Path 1903",
								d: "M-1452.871,1309.876v-2.214h3.457Z",
								transform: "translate(1465.059 -1294.928)",
								fill: "#ccc"
							})]
						}), /* @__PURE__ */ _jsxs("g", {
							id: "Group_1132",
							"data-name": "Group 1132",
							transform: "translate(6.544 4.724)",
							children: [/* @__PURE__ */ _jsx("g", {
								id: "Group_1130",
								"data-name": "Group 1130",
								transform: "translate(2.403)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1904",
									"data-name": "Path 1904",
									d: "M-1463.025,1287.213a.347.347,0,0,1-.347-.347v-4.805a.347.347,0,0,1,.347-.347.348.348,0,0,1,.348.347v4.805A.347.347,0,0,1-1463.025,1287.213Z",
									transform: "translate(1463.372 -1281.713)",
									fill: "#ccc"
								})
							}), /* @__PURE__ */ _jsx("g", {
								id: "Group_1131",
								"data-name": "Group 1131",
								transform: "translate(0 2.402)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1905",
									"data-name": "Path 1905",
									d: "M-1466,1290.191h-4.805a.347.347,0,0,1-.347-.347.347.347,0,0,1,.347-.348H-1466a.348.348,0,0,1,.348.348A.347.347,0,0,1-1466,1290.191Z",
									transform: "translate(1471.155 -1289.496)",
									fill: "#ccc"
								})
							})]
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						id: "Group_1134",
						"data-name": "Group 1134",
						transform: "translate(45.921 39.28)",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Path_1906",
							"data-name": "Path 1906",
							d: "M-1370.869,1318.284a56.283,56.283,0,0,1-1.632,12.784l-3.457,2.164h-12.188c2.316-6.162,2.33-14.948,2.33-14.948Z",
							transform: "translate(1388.147 -1318.284)",
							fill: "#e3e4e5"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1907",
							"data-name": "Path 1907",
							d: "M-1348.662,1361.751v-2.214h3.457Z",
							transform: "translate(1360.85 -1346.803)",
							fill: "#e3e4e5"
						})]
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_1136",
				"data-name": "Group 1136",
				transform: "translate(-1510.522 1209.035)",
				children: [/* @__PURE__ */ _jsxs("g", {
					id: "Attention_banner",
					"data-name": "Attention banner",
					transform: "translate(0)",
					children: [/* @__PURE__ */ _jsxs("g", {
						id: "Banner",
						children: [/* @__PURE__ */ _jsx("path", {
							id: "Shadow",
							d: "M-1338.91,1296.949h-2.232l-5.091,5.091v.849l5.091-5.092h2.232a3.46,3.46,0,0,0,3.677-3.677v-.849A3.46,3.46,0,0,1-1338.91,1296.949Z",
							transform: "translate(1362.325 -1279.712)",
							fill: "#061a3d"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1908",
							"data-name": "Path 1908",
							d: "M-1374.948,1249.345h-19.739a3.46,3.46,0,0,0-3.677,3.677v9.882a3.46,3.46,0,0,0,3.677,3.677h12.415v5.092l5.092-5.092h2.232a3.46,3.46,0,0,0,3.677-3.677v-9.882A3.46,3.46,0,0,0-1374.948,1249.345Z",
							transform: "translate(1398.364 -1249.345)",
							fill: "#032478"
						})]
					}), /* @__PURE__ */ _jsxs("g", {
						id: "Sign",
						transform: "translate(7.606 2.678)",
						children: [/* @__PURE__ */ _jsx("circle", {
							id: "Ellipse_69",
							"data-name": "Ellipse 69",
							cx: 5.94,
							cy: 5.94,
							r: 5.94,
							fill: "#fff"
						}), /* @__PURE__ */ _jsx("path", {
							id: "Path_1909",
							"data-name": "Path 1909",
							d: "M-1356.5,1270.475c.994,0,.819.894.84.968,0,.566-.065.937-.891.937-.785,0-1.013-.185-1.013-.967C-1357.565,1270.6-1357.264,1270.475-1356.5,1270.475Zm-.117-.794c-.77,0-.9-.184-.9-.784v-3.228c0-.586.123-.8.906-.8.8,0,.9.235.9.815v3.228C-1355.711,1269.435-1355.774,1269.681-1356.618,1269.681Z",
							transform: "translate(1362.553 -1262.752)",
							fill: "#032478"
						})]
					})]
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_1910",
					"data-name": "Path 1910",
					d: "M-1392.28,1296.949h-2.262a3.484,3.484,0,0,1-3.727-3.677v.849a3.484,3.484,0,0,0,3.727,3.677h12.336v-.849h-10.074Z",
					transform: "translate(1398.298 -1279.712)",
					fill: "#061a3d"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_1169",
				"data-name": "Group 1169",
				transform: "translate(-1560.603 1205.25)",
				children: [
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1139",
						"data-name": "Group 1139",
						transform: "translate(0.025 30.679)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1138",
							"data-name": "Group 1138",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_1137",
								"data-name": "Group 1137",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_1911",
									"data-name": "Path 1911",
									d: "M-1558.2,1336.762a2.176,2.176,0,0,1,.281.743,3.573,3.573,0,0,0,.343.878,8.33,8.33,0,0,1,.417,1.463,6.72,6.72,0,0,0-.2.979c.033.212.155.632-.036.66s-.406-.316-.406-.316a.28.28,0,0,1-.143.27.472.472,0,0,1-.479.017s-.115.214-.26.243a.591.591,0,0,1-.476-.064.576.576,0,0,1-.362.116.473.473,0,0,1-.4-.25s-.358.073-.462-.094a1.6,1.6,0,0,1-.129-.5,5.779,5.779,0,0,1,.454-2.5,2.215,2.215,0,0,0-.118-1.943Z",
									transform: "translate(1560.522 -1336.468)",
									fill: "#eea886"
								})
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1141",
						"data-name": "Group 1141",
						transform: "translate(0 33.446)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1140",
							"data-name": "Group 1140",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1912",
								"data-name": "Path 1912",
								d: "M-1557.8,1347.24s.032-1.226-.291-1.487-.359.181-.359.181.044-.437-.309-.5-.367.46-.367.46a.34.34,0,0,0-.428-.267c-.37.069-.282.5-.282.5s-.354-.422-.583-.017a1.864,1.864,0,0,0-.035,1.5s.123.2.475.11a.491.491,0,0,0,.766.138s.555.3.752-.176A.452.452,0,0,0-1557.8,1347.24Z",
								transform: "translate(1560.603 -1345.434)",
								fill: "#db9c7c"
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1913",
						"data-name": "Path 1913",
						d: "M-1553.9,1273.812s-2.1,6.993-2.807,9.572c-.223.809-.761,8.535-.855,8.846s-2.756.737-2.756.737.322-9.665.353-10.192,2.936-11.32,3.782-11.7c.633-.288.967-.05,1.765.543A1.868,1.868,0,0,1-1553.9,1273.812Z",
						transform: "translate(1560.409 -1260.494)",
						fill: "#677af4"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1142",
						"data-name": "Group 1142",
						transform: "translate(26.967 0.379)",
						children: /* @__PURE__ */ _jsx("rect", {
							id: "Rectangle_9998",
							"data-name": "Rectangle 9998",
							width: 5.74,
							height: .426,
							transform: "translate(0 3.143) rotate(-33.197)",
							fill: "#4da8f2"
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1914",
						"data-name": "Path 1914",
						d: "M-1463.179,1240.881a1.252,1.252,0,0,1-.124.381s-.157.187-.261.327a1.262,1.262,0,0,0-.075.111,2.287,2.287,0,0,1-.4.617c-.229.232-1.119.97-1.119.97l-.763-.648-.792-.355a14.925,14.925,0,0,1,.632-2.169.79.79,0,0,1,.058-.066,2.9,2.9,0,0,1,.5-.342c.039-.032.447-.326.592-.288a.491.491,0,0,1,.366.306,1.174,1.174,0,0,1,.543.349.73.73,0,0,1,.472.438S-1463.195,1240.654-1463.179,1240.881Z",
						transform: "translate(1495.694 -1238.696)",
						fill: "#efaa88"
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1144",
						"data-name": "Group 1144",
						transform: "translate(2.29 60.893)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1143",
							"data-name": "Group 1143",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1915",
								"data-name": "Path 1915",
								d: "M-1550.672,1434.519s-.191,1.327-.215,1.527-2.127-.117-2.127-.117l-.17-1.58A12.456,12.456,0,0,1-1550.672,1434.519Z",
								transform: "translate(1553.185 -1434.348)",
								fill: "#424773"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1146",
						"data-name": "Group 1146",
						transform: "translate(1.961 62.332)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1145",
							"data-name": "Group 1145",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1916",
								"data-name": "Path 1916",
								d: "M-1551.6,1439.1a5.686,5.686,0,0,0,1.311,1.149c.645.348,1.658.487,2.039.848.275.26,1,1.382-1.675,1.359s-3.969.158-4.255-.271.415-3.174.415-3.174A5.667,5.667,0,0,0-1551.6,1439.1Z",
								transform: "translate(1554.25 -1439.011)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1148",
						"data-name": "Group 1148",
						transform: "translate(17.363 60.893)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1147",
							"data-name": "Group 1147",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1917",
								"data-name": "Path 1917",
								d: "M-1501.842,1434.519s-.191,1.327-.215,1.527-2.128-.117-2.128-.117l-.17-1.58A12.458,12.458,0,0,1-1501.842,1434.519Z",
								transform: "translate(1504.355 -1434.348)",
								fill: "#424773"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1150",
						"data-name": "Group 1150",
						transform: "translate(17.034 62.332)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1149",
							"data-name": "Group 1149",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1918",
								"data-name": "Path 1918",
								d: "M-1502.771,1439.1a5.683,5.683,0,0,0,1.311,1.149c.645.348,3.017.635,3.4,1,.275.26.733,1.309-3.034,1.211-2.676-.07-3.968.158-4.255-.271s.415-3.174.415-3.174A5.142,5.142,0,0,0-1502.771,1439.1Z",
								transform: "translate(1505.42 -1439.011)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1152",
						"data-name": "Group 1152",
						transform: "translate(1.961 26.952)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1151",
							"data-name": "Group 1151",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1919",
								"data-name": "Path 1919",
								d: "M-1549.666,1324.4s-1.977,3.141-1.829,5.979-.717,5.938-1.014,8.9c-.331,3.306-1.686,11.133-1.735,12.9s.21,7.415.21,7.415l2.712.062s2.278-13.683,2.868-15.079,3.515-11.349,3.613-12.466S-1549.666,1324.4-1549.666,1324.4Z",
								transform: "translate(1554.25 -1324.396)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1154",
						"data-name": "Group 1154",
						transform: "translate(5.55 26.411)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1153",
							"data-name": "Group 1153",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1920",
								"data-name": "Path 1920",
								d: "M-1531.223,1323.61s1.49,7.781,1.687,9.518.328,8.408.426,9.494.918,14.178,1.18,15.824h-3.467s-2.661-9.541-2.661-14.055-2.056-9.814-3.383-12.792-4.365-3.049-5.181-8.575C-1542.623,1323.024-1532.327,1321.858-1531.223,1323.61Z",
								transform: "translate(1542.623 -1322.644)",
								fill: "#292c47"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1156",
						"data-name": "Group 1156",
						transform: "translate(8.183 0.306)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1155",
							"data-name": "Group 1155",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1921",
								"data-name": "Path 1921",
								d: "M-1532.434,1238.316s2.653-.991,3.877,1.029,1.106,6.063-.232,6.56-3.346.237-4.031-1.026a10.121,10.121,0,0,1-1.273-4.312A2.66,2.66,0,0,1-1532.434,1238.316Z",
								transform: "translate(1534.094 -1238.073)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1158",
						"data-name": "Group 1158",
						transform: "translate(8.939 5.712)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1157",
							"data-name": "Group 1157",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1922",
								"data-name": "Path 1922",
								d: "M-1527.384,1258.1a2.3,2.3,0,0,0,.072,1.069c.183.353-3.437.362-3.437.362a23.848,23.848,0,0,0-.851-3.541C-1532.157,1254.373-1527.384,1258.1-1527.384,1258.1Z",
								transform: "translate(1531.646 -1255.586)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1160",
						"data-name": "Group 1160",
						transform: "translate(7.962)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1159",
							"data-name": "Group 1159",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1923",
								"data-name": "Path 1923",
								d: "M-1533.787,1243.2s.25.412,1.27.252,2.264-1.516,2.689-1.666.43-.4.43-.4l.266.39.452.028s-.413-1.214.21-1.708-.646-3.928-3.916-2.785c0,0-2.512.692-2.421,2.121A7.945,7.945,0,0,0-1533.787,1243.2Z",
								transform: "translate(1534.809 -1237.083)",
								fill: "#fccca2"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1162",
						"data-name": "Group 1162",
						transform: "translate(9.422 8.265)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1161",
							"data-name": "Group 1161",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1924",
								"data-name": "Path 1924",
								d: "M-1526.016,1264.849s-.011-.674-.317-.739a21.814,21.814,0,0,0-3.748-.212v.785S-1529.358,1265.128-1526.016,1264.849Z",
								transform: "translate(1530.081 -1263.857)",
								fill: "#e2d2ca"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1164",
						"data-name": "Group 1164",
						transform: "translate(12.352 3.267)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1163",
							"data-name": "Group 1163",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1925",
								"data-name": "Path 1925",
								d: "M-1519.634,1248.188c-.057-.24-.666-.924-.9-.191s.353,1.719.679,1.635S-1519.489,1248.8-1519.634,1248.188Z",
								transform: "translate(1520.587 -1247.667)",
								fill: "#eea886"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1166",
						"data-name": "Group 1166",
						transform: "translate(3.698 3.25)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1165",
							"data-name": "Group 1165",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1926",
								"data-name": "Path 1926",
								d: "M-1533.759,1254.638c-2.1-.277-5.074-1.021-5.074-1.021l-4.066-.166a39.539,39.539,0,0,0-5.2,1.485c-.14.063-.14,3.329-.523,4.185l1.218,2.57s.7,5.091.849,7.356c.067,1.039-1.451,9.747-1.451,9.747a28.082,28.082,0,0,0,4.4.785c2.775.306,9.707-.111,9.751-.438s-1.343-12.2-1.4-12.818c-.094-.944.325-5.959.325-5.959.641-.5,6.265-3.108,7.8-4.468.411-.364,2.144-2.052,2.637-2.635a47.3,47.3,0,0,0,3.349-4.214c.2-.217-1.948-1.372-2.137-1.435-.167-.055-2.473,3.017-3.381,4a25.413,25.413,0,0,1-2.087,1.662S-1532.444,1254.713-1533.759,1254.638Z",
								transform: "translate(1548.622 -1247.61)",
								fill: "#7284fa"
							})
						})
					}),
					/* @__PURE__ */ _jsx("g", {
						id: "Group_1168",
						"data-name": "Group 1168",
						transform: "translate(7.553 0.787)",
						children: /* @__PURE__ */ _jsx("g", {
							id: "Group_1167",
							"data-name": "Group 1167",
							children: /* @__PURE__ */ _jsx("path", {
								id: "Path_1927",
								"data-name": "Path 1927",
								d: "M-1534.6,1239.632s-3.383.265-.1,5.333Z",
								transform: "translate(1536.135 -1239.632)",
								fill: "#fccca2"
							})
						})
					}),
					/* @__PURE__ */ _jsx("path", {
						id: "Path_1928",
						"data-name": "Path 1928",
						d: "M-1457.451,1238.516l.277-.424-.511.067Z",
						transform: "translate(1489.454 -1237.781)",
						fill: "#dfe1e8"
					})
				]
			})
		]
	})
});
export default SvgCompletedControlEmptyState;
